import { CISCO_HYPERFLEX_HW_LIST } from "./constants";
import HardwareImage from "public/cisco-hyperflex/cisco-hyperflex-hw-sw.webp";
import { Flex, Icon, Text, AspectRatio } from "@chakra-ui/react";
import Image from "next/image";
import { Md2ArrowRightDropCircleOutline } from "@onemind-services-llc/react-icons-ng/md2";
import { SectionDivider } from "app/components/shared/SectionDivider";

const HardwareSoftware = () => {
  return (
    <>
      <SectionDivider label="Hardware And Software" />
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={10}
        justifyContent={"center"}
        alignItems={"center"}
        mt={5}
        mb={5}
        data-cy="section-hardware"
      >
        <AspectRatio
          position={"relative"}
          width={{ base: "full", sm: "300px", md: "400px", lg: "450px" }}
        >
          <Image
            alt={"Hardware and software"}
            title={"Hardware and software"}
            fill
            src={HardwareImage}
            sizes="(max-width: 1080px) 100vw, 450px"
            style={{ objectFit: "contain", objectPosition: "center" }}
          />
        </AspectRatio>
        <Flex direction={"column"} gap={2}>
          {CISCO_HYPERFLEX_HW_LIST.map((item, index) => {
            return (
              <Flex key={index} gap={4}>
                <Icon
                  as={Md2ArrowRightDropCircleOutline}
                  color={"brand.100"}
                  fontSize={"25px"}
                />
                <Text fontSize={"18px"} color={"gray.800"}>
                  {item}
                </Text>
              </Flex>
            );
          })}
        </Flex>
      </Flex>
    </>
  );
};

export default HardwareSoftware;
